/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

// mui Icons
import CloseIcon from "@mui/icons-material/Close";

function ProjectModal({ projectData, isVisible, toggleCallback }) {
  if (projectData) {
    return (
      <Modal
        open={isVisible}
        onClose={toggleCallback}
        xs={12}
        sm={10}
        md={7}
        lg={6}
        xl={6}
        sx={{
          display: "grid",
          placeItems: "center",
          overflow: "scroll",
        }}
      >
        <Slide direction="down" in={isVisible} timeout={500}>
          <MKBox
            position="relative"
            width="75vw"
            display="flex"
            flexDirection="column"
            borderRadius="xl"
            bgColor="info"
            variant="gradient"
            shadow="xl"
          >
            <MKBox display="flex" alignItems="top" justifyContent="right" pt={2} pr={2}>
              <CloseIcon
                fontSize="medium"
                sx={{ cursor: "pointer" }}
                onClick={toggleCallback}
                color="white"
              />
            </MKBox>
            <Grid
              container
              spacing={0}
              alignItems="flex-start"
              justifyContent="space-between"
              sx={{
                flexDirection: {
                  xs: "column",
                  md: "row",
                },
              }}
            >
              <Grid item>
                <MKBox display="flex" flexDirection="column" alignItems="top" p={2}>
                  {projectData.GetName ? (
                    <MKTypography variant="h1" color="white">
                      {projectData.GetName}
                    </MKTypography>
                  ) : (
                    ""
                  )}
                </MKBox>
              </Grid>
              <Grid item>
                <MKBox
                  display="flex"
                  flexDirection="column"
                  alignItems="top"
                  justifyContent="right"
                  p={2}
                >
                  {projectData.GetGenre ? (
                    <MKTypography variant="body2" fontWeight="regular" color="white">
                      <strong>Genre:</strong> {projectData.GetGenre}
                    </MKTypography>
                  ) : (
                    ""
                  )}
                  {projectData.GetShipInfo ? (
                    <MKTypography variant="body2" fontWeight="regular" color="white">
                      <strong>Shipped:</strong> {projectData.GetShipInfo}
                    </MKTypography>
                  ) : (
                    ""
                  )}
                  {projectData.GetMyRole ? (
                    <MKTypography variant="body2" fontWeight="regular" color="white">
                      <strong>My Role:</strong> {projectData.GetMyRole}
                    </MKTypography>
                  ) : (
                    ""
                  )}
                  {projectData.GetTools ? (
                    <MKTypography variant="body2" fontWeight="regular" color="white">
                      <strong>Tools:</strong> {projectData.GetTools}
                    </MKTypography>
                  ) : (
                    ""
                  )}
                </MKBox>
              </Grid>
            </Grid>
            <hr color="white" />
            <MKBox p={2} bgColor="#343434">
              {projectData.GetAbout ? (
                <>
                  <MKTypography variant="h4" color="white" fontWeight="bold">
                    About:
                  </MKTypography>
                  <MKTypography variant="body2" color="white" mb={2}>
                    {projectData.GetAbout}
                  </MKTypography>
                </>
              ) : (
                ""
              )}
              {projectData.GetContributions ? (
                <>
                  <MKTypography variant="h4" color="white" fontWeight="bold">
                    My Contributions:
                  </MKTypography>
                  <List sx={{ listStyleType: "disc", paddingLeft: "40px" }}>
                    {Array.from(projectData.GetContributions).map((item, index) => (
                      <ListItem
                        key={projectData.GetNameNoSpaces + "_cont_" + index}
                        sx={{ display: "list-item" }}
                      >
                        {item.blurb}
                      </ListItem>
                    ))}
                  </List>
                </>
              ) : (
                ""
              )}
            </MKBox>
            {projectData.GetVideoUrl ? (
              <>
                <MKBox
                  p={2}
                  bgColor="#343434"
                  display="flex"
                  width="100%"
                  alignItems="center"
                  justifyContent="center"
                >
                  <iframe
                    width="560"
                    height="315"
                    src={projectData.GetVideoUrl}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </MKBox>
              </>
            ) : (
              ""
            )}
            {projectData.GetVideoList
              ? Array.from(projectData.GetVideoList).map((video, index) => (
                  <div key={projectData.GetNameNoSpaces + "_vcont_" + index}>
                    <MKBox
                      key={projectData.GetNameNoSpaces + "_vurlcont_" + index}
                      p={2}
                      bgColor="#343434"
                      display="flex"
                      width="100%"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <MKBox
                        key={projectData.GetNameNoSpaces + "_vurl_" + index}
                        width="100%"
                        display="flex"
                        justifyContent="center"
                        p={1}
                      >
                        <iframe
                          key={projectData.GetNameNoSpaces + "_vurlif_" + index}
                          width="560"
                          height="315"
                          src={video.videoUrl}
                          title="YouTube video player"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        ></iframe>
                      </MKBox>
                    </MKBox>
                  </div>
                ))
              : ""}
            <hr color="white" />
            <MKBox display="flex" justifyContent="center" p={1.5}>
              <MKButton color="white" onClick={toggleCallback}>
                close
              </MKButton>
            </MKBox>
          </MKBox>
        </Slide>
      </Modal>
    );
  }
}

ProjectModal.propTypes = {
  projectData: PropTypes.any.isRequired,
  isVisible: PropTypes.bool.isRequired,
  toggleCallback: PropTypes.func.isRequired,
};

export default ProjectModal;
